import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlus, FiUsers, FiBarChart3, FiArrowRight } = FiIcons;

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-4xl mx-auto"
        >
          <h1 className="text-5xl font-bold text-primary mb-6">
            Survey Visualizer
          </h1>
          <p className="text-xl text-primary mb-12 leading-relaxed">
            Erstellen Sie interaktive Umfragen und visualisieren Sie Ergebnisse in Echtzeit. 
            Keine Anmeldung erforderlich - teilen Sie einfach den Link!
          </p>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="bg-white rounded-lg p-6 shadow-lg border border-gray-100"
            >
              <SafeIcon icon={FiPlus} className="text-3xl text-primary mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-primary mb-2">Umfrage erstellen</h3>
              <p className="text-primary">Erstellen Sie Umfragen mit 2-5 Kategorien in Sekunden</p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="bg-white rounded-lg p-6 shadow-lg border border-gray-100"
            >
              <SafeIcon icon={FiUsers} className="text-3xl text-primary mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-primary mb-2">Teilnehmer einladen</h3>
              <p className="text-primary">Teilen Sie den Link oder QR-Code für einfache Teilnahme</p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="bg-white rounded-lg p-6 shadow-lg border border-gray-100"
            >
              <SafeIcon icon={FiBarChart3} className="text-3xl text-primary mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-primary mb-2">Live Visualisierung</h3>
              <p className="text-primary">Sehen Sie Ergebnisse in Echtzeit mit dynamischen Größen</p>
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <Link
              to="/create"
              className="btn-primary inline-flex items-center font-semibold py-4 px-8 rounded-lg shadow-lg"
            >
              <SafeIcon icon={FiPlus} className="mr-2" />
              Neue Umfrage erstellen
              <SafeIcon icon={FiArrowRight} className="ml-2" />
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default HomePage;